var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__caret--wide--system icon--style--fill icon--size--small",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.956 4.98a.75.75 0 00-.708-.48H.748a.749.749 0 00-.7.481.7.7 0 00.236.8l7.25 5.563a.774.774 0 00.938 0l7.25-5.563a.7.7 0 00.234-.801z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }